import * as Sentry from '@sentry/react';

const locationServiceUrl = 'https://freegeoip.app/json/';

export async function getUserCountryByIP() {
  try {
    const response = await fetch(locationServiceUrl);
    const location = await response.json();
    return location.country_code;
  } catch (e) {
    Sentry.captureException(e);
    return undefined;
  }
}
